export const GET_CONTRACTORS_REQUEST = "GET_CONTRACTORS_REQUEST";
export const GET_CONTRACTORS_REQUEST_SUCCESS = "GET_CONTRACTORS_REQUEST_SUCCESS";
export const CREATE_CONTRACTOR_REQUEST = "CREATE_CONTRACTOR_REQUEST";
export const CREATE_CONTRACTOR_REQUEST_SUCCESS = "CREATE_CONTRACTOR_REQUEST_SUCCESS";

import {Contractor} from "../../interfaces/Contractors";


export default (state : Contractor[] = [], action) => {
    switch (action.type){
        case GET_CONTRACTORS_REQUEST_SUCCESS:
            return Object.assign(state, action.payload);
        default:
            return state;
    }
}